import { WeightUnit, WeightUnitToGramsConversionMap } from "@shared/index";

export type WeightDecimals = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
export const DEFAULT_WEIGHT_DECIMALS: WeightDecimals = 3;
export const WEIGHT_UNITS: WeightUnit[] = ["g", "kg", "oz", "lb", "gm"];
export const WEIGHT_UNIT_TO_GRAMS_MAP: WeightUnitToGramsConversionMap = {
  oz: 28.3495,
  lb: 453.592,
  kg: 1000,
  gm: 1,
  g: 1,
};

export const stringToWeightUnit = (unit: string) => {
  return WEIGHT_UNITS.includes(unit as WeightUnit) ? (unit as WeightUnit) : undefined;
};

export const calculateTotalWeightInGrams = (weight: number, weightUnit: WeightUnit) => {
  const conversionFactor = WEIGHT_UNIT_TO_GRAMS_MAP[weightUnit];
  return weight * conversionFactor;
};

export const detectWeightAndUnitFromBagSize = (bagSize: string) => {
  const [, detectedWeightString, , detectedUnit] = /^(\d{1,20}(\.\d{1,10})?)([a-zA-Z\s]{1,20})$/.exec(bagSize) ?? [];
  const parsedWeight = detectedWeightString ? Number.parseFloat(detectedWeightString) : undefined;
  return { parsedWeight, detectedUnit };
};

export const calculateWeightFromBagSize = (bagSize?: string) => {
  if (!bagSize) {
    return;
  }
  const { parsedWeight, detectedUnit } = detectWeightAndUnitFromBagSize(bagSize);
  if (!parsedWeight || !detectedUnit) {
    return;
  }
  const weightUnit = stringToWeightUnit(detectedUnit?.trim().toLowerCase());
  if (!weightUnit) {
    return;
  }
  const convertedWeightInGrams = calculateTotalWeightInGrams(parsedWeight, weightUnit);
  return convertedWeightInGrams;
};

export const parseWeightFromBagSize = (bagSize?: string, decimalPlaces: WeightDecimals = DEFAULT_WEIGHT_DECIMALS) => {
  const convertedWeightInGrams = calculateWeightFromBagSize(bagSize);
  if (!convertedWeightInGrams) {
    return;
  }
  return convertedWeightInGrams.toFixed(decimalPlaces);
};
